<sdps-modal-beta (close)="onModalClose($event)" [attr.sdps-title]="title" id="cancel-modal-v2">
  <div slot="modal-body">
    <div class="sdps-text-body" *ngFor="let items of textBody">{{items}}</div>
  </div>
  <div slot="modal-footer">
    <button (click)="onCancelClick()" type="button"
      class="sdps-button sdps-button--small sdps-button--secondary">{{grayButton}}</button>
    <button (click)="onContinueClick()" type="button"
      class="sdps-button sdps-button--primary sdps-button--small" id="lc_cancel_continue">{{greenButton}}</button>
  </div>
</sdps-modal-beta>
